import { useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { RosaryFocusView } from "@/components/rosary/RosaryFocusView";
import { useRosaryController } from "@/components/rosary/useRosaryController";

export default function RosaryPopoutPage() {
  const controller = useRosaryController();
  const navigate = useNavigate();
  const close = () => {
    controller.pause();
    if (window.opener && !window.opener.closed) { window.opener.focus(); window.close(); }
    // Direct links and browsers that refuse scripted closing remain usable.
    navigate("/rosary#pray", { replace: true });
  };
  return <main data-testid="rosary-popout-container"><Seo /><RosaryFocusView controller={controller} onClose={close} popout /></main>;
}